import { useEffect, useState } from 'react';
import { useChannelEvent } from '../../../../../../realtime';
import { useDashboard } from '../../../../../../store/dashboard';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../../../../config/routes';
import Loading from '../../../../../common/loading';
import './styles.scss';
import l from '../../../../../../lang';

function LegalTalentForm() {
  const { merchantMe, getMerchantMe } = useDashboard();
  const [isKyc2SessionCreated, setIsKyc2SessionCreated] = useState(false);

  const [formLoading, setFormLoading] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    setFormLoading(!(iframeLoaded && isKyc2SessionCreated && merchantMe?.legalTalentAccessLink));
  }, [iframeLoaded, isKyc2SessionCreated, merchantMe?.legalTalentAccessLink]);

  useEffect(() => {
    setIsKyc2SessionCreated(merchantMe?.legalTalentAccessLink != null);
  }, []);

  const history = useHistory();

  const updateMerchantMeAndRedirect = () => {
    getMerchantMe();
    history.push(Routes.HOME);
  };

  useChannelEvent({
    channelName: `kyc2-form-${merchantMe?.id}`,
    eventName: 'kyc2-session-created',
    listener: (payload: any) => {
      console.log('kyc2-session-created', payload);
      setIsKyc2SessionCreated(true);
      getMerchantMe();
    },
  });

  useChannelEvent({
    channelName: `kyc2-form-${merchantMe?.id}`,
    eventName: 'kyc2-session-completed',
    listener: (payload: any) => {
      console.log('kyc2-session-completed', payload);
      updateMerchantMeAndRedirect();
    },
  });

  useChannelEvent({
    channelName: `kyc2-form-${merchantMe?.id}`,
    eventName: 'kyc2-session-rejected',
    listener: (payload: any) => {
      console.log('kyc2-session-rejected');
      updateMerchantMeAndRedirect();
    },
  });

  return (
    <div className="legal-talent-form">
      {formLoading && (
        <div className="legal-talent-form__loading">
          <Loading />
          <h3>{l('companyInformation.kycTwo.legalTalent.loading.title')}</h3>
          <h4>{l('companyInformation.kycTwo.legalTalent.loading.subtitle')}</h4>
        </div>
      )}
      {isKyc2SessionCreated && merchantMe?.legalTalentAccessLink && (
        <iframe
          src={merchantMe?.legalTalentAccessLink}
          style={{
            width: iframeLoaded ? '100%' : '0',
            height: iframeLoaded ? '100%' : '0',
            opacity: iframeLoaded ? 1 : 0,
          }}
          onLoad={() => setIframeLoaded(true)}
        />
      )}
    </div>
  );
}

export default LegalTalentForm;
